import { getDashboardCountDataAPI, getDashboardLocationDataAPI, getFaultNonFaultyDataAPI, getOnlineOfflineDataAPI } from "./apis";
import *  as commonActions from "../../../../common/actions";
import { errorMessage } from "../../../../../utils";
// Graph Data
export const GET_GRAPH_DATA = 'GET_GRAPH_DATA';
// 
export const GET_DASHBOARD_COUNT_REQUEST = 'GET_DASHBOARD_COUNT_REQUEST';
export const GET_DASHBOARD_COUNT_SUCCESS = 'GET_DASHBOARD_COUNT_SUCCESS';
export const GET_DASHBOARD_COUNT_FAILED = 'GET_DASHBOARD_COUNT_FAILED';
export const UPDATE_DASHBOARD_COUNT_SUCCESS = 'UPDATE_DASHBOARD_COUNT_SUCCESS';

export const getDashboardCount = () => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_DASHBOARD_COUNT_REQUEST
    })
    getDashboardCountDataAPI().then(res => {
      dispatch({
        type: GET_DASHBOARD_COUNT_SUCCESS,
        payload: res && res.info || {}
      })
      return resolve(res)
    }).catch(err => {
      dispatch({
        type: GET_DASHBOARD_COUNT_FAILED
      })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })

export const GET_DASHBOARD_LOCATION_DATA_REQUEST = 'GET_DASHBOARD_LOCATION_DATA_REQUEST';
export const GET_DASHBOARD_LOCATION_DATA_SUCCESS = 'GET_DASHBOARD_LOCATION_DATA_SUCCESS';
export const GET_DASHBOARD_LOCATION_DATA_FAILED = 'GET_DASHBOARD_LOCATION_DATA_FAILED';

export const getDashboardLocationData = (data) => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({
      type: GET_DASHBOARD_LOCATION_DATA_REQUEST
    })
    getDashboardLocationDataAPI(data).then(res => {
      dispatch({
        type: GET_DASHBOARD_LOCATION_DATA_SUCCESS,
        payload: res && res.info || {}
      })
      return resolve(res)
    }).catch(err => {
      dispatch({
        type: GET_DASHBOARD_LOCATION_DATA_FAILED
      })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })

export const updateDashboardCount = (data) => dispatch => {
  try {
    dispatch({
      type: UPDATE_DASHBOARD_COUNT_SUCCESS,
      payload: data || {},
    })
  } catch (error) {
    dispatch({
      type: GET_DASHBOARD_COUNT_FAILED
    })
  }
}


export const GET_ONLINE_OFFLINE_REQUEST = 'GET_ONLINE_OFFLINE_REQUEST';
export const GET_ONLINE_OFFLINE_SUCCESS = 'GET_ONLINE_OFFLINE_SUCCESS';
export const GET_ONLINE_OFFLINE_FAILED = 'GET_ONLINE_OFFLINE_FAILED';

export const getOnlineOfflineData = (year) => dispatch =>

  new Promise((resolve, reject) => {
    dispatch({
      type: GET_ONLINE_OFFLINE_REQUEST
    })
    getOnlineOfflineDataAPI(year).then(res => {
      dispatch({
        type: GET_ONLINE_OFFLINE_SUCCESS,
        payload: res && res.info || {}
      })
      return resolve(res)
    }).catch(err => {
      dispatch({
        type: GET_ONLINE_OFFLINE_FAILED
      })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })

export const GET_FAULT_NON_FAULTY_REQUEST = 'GET_FAULT_NON_FAULTY_REQUEST';
export const GET_FAULT_NON_FAULTY_SUCCESS = 'GET_FAULT_NON_FAULTY_SUCCESS';
export const GET_FAULT_NON_FAULTY_FAILED = 'GET_FAULT_NON_FAULTY_FAILED';

export const getFaultnonFaultyData = (year) => dispatch =>

  new Promise((resolve, reject) => {
    dispatch({
      type: GET_FAULT_NON_FAULTY_REQUEST
    })
    getFaultNonFaultyDataAPI(year).then(res => {
      dispatch({
        type: GET_FAULT_NON_FAULTY_SUCCESS,
        payload: res && res.info || {}
      })
      return resolve(res)
    }).catch(err => {
      dispatch({
        type: GET_FAULT_NON_FAULTY_FAILED
      })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })